"use client";
function u(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
export {
  u as o
};
